import { render } from "./ssoRedirect.vue?vue&type=template&id=6b22c210"
import script from "./ssoRedirect.vue?vue&type=script&lang=js"
export * from "./ssoRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__